import React, { lazy, Suspense, useState, useCallback } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col
} from "reactstrap";
import { commonText, dashboard } from "../../locales/en";
import LoginAsUser from "../../components/loginasuser/LoginAsUser";
import ErrorBoundary from "../../components/error-boundary";
import ComponentViewFallback from "../../components/error-boundary/fallback/ComponentViewFallback";
import "../../assets/scss/invoice.scss";
import { ACTIVE, STATUS_1 } from "../../utils/constants/appConstants";

const CustomerTable = lazy(
  () => import("../../components/table/customertable/CustomerTable")
);

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState(STATUS_1);

  const handleTabChange = useCallback((tabId) => setActiveTab(tabId), []);

  return (
    <>
      <LoginAsUser />

      <div className="invoice-page-wrap">
        <div className="invoice-page-tab-wrap">
          <Nav tabs className="invoice-nav">
            <NavItem>
              <NavLink
                className={activeTab === STATUS_1 ? ACTIVE : ""}
                onClick={() => handleTabChange(STATUS_1)}
              >
                {dashboard?.invoiceTabName}
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab} id="invoice-tabcontent">
            <TabPane tabId={STATUS_1}>
              <Row>
                <Col sm="12">
                  <ErrorBoundary fallback={<ComponentViewFallback />}>
                    <Suspense
                      fallback={
                        <div className="text-center py-4">
                          {commonText.fallbackLoader}
                        </div>
                      }
                    >
                      <CustomerTable />
                    </Suspense>
                  </ErrorBoundary>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </>
  );
};

export default React.memo(Dashboard);
